var select = function () {

    //detect pointer events
    var pointerEventsSupported = (function () {
        var element = document.createElement('x'),
            documentElement = document.documentElement,
            getComputedStyle = window.getComputedStyle,
            supports;
        if (!('pointerEvents' in element.style)) {
            return false;
        }
        element.style.pointerEvents = 'auto';
        element.style.pointerEvents = 'x';
        documentElement.appendChild(element);
        supports = getComputedStyle &&
            getComputedStyle(element, '').pointerEvents === 'auto';
        documentElement.removeChild(element);
        return !!supports;
    })();

    //if supported add custom select wrapper
    if (pointerEventsSupported) {
        var selects = $('.m-wysiwyg select, .m-form select').each(function() {
            var parentElements = $(this).parents("span.custom-select");

            if (parentElements.length <= 0) {
                $(this).wrap('<span class="custom-select" />');
            }
        });
    }
}